import type { IHubSpotData } from '../../types';

// sandbox and production data
export const demoFormData: IHubSpotData[] = [
  //ENGLISH MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
    'name': ' Main Demo Form - English (EN)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Submit',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'First name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Last name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Email Address',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Phone number',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Company Website',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Number of contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1K',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 3K',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 25K',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 100K',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 500K',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M+',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741162807129,
    'updatedAt': 1744832414115,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'en',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":537028710,"label":"You consent to receive Klaviyo’s marketing communications including newsletters, blog posts, product news, webinars, and targeted advertising. You can unsubscribe from our marketing emails at any time by clicking on the “Unsubscribe” link at the bottom of our emails. For more information, please see our <a href=\\"https://www.klaviyo.com/legal/privacy/privacy-notice\\" rel=\\"noopener\\">Privacy Policy</a>.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"I agree to allow Klaviyo Sandbox to store and process my personal data.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743856,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744832414115,
    'businessUnitId': 0,
    'portableKey': 'c1da9580-9d03-4616-96a8-b193b37ca03e',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // FRENCH MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': 'bc51f195-7772-4a17-b5b8-8f152c063914',
    'name': 'Main Demo Form - French (FR)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Soumettre',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Prénom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Adresse e-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numéro de téléphone',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Site web de l’entreprise',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Nombre de contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1&nbsp;000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1&nbsp;000 - 3&nbsp;000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3&nbsp;000 - 25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000 - 100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000 - 500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000 - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M et +',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source&#xa0;',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date_time',
            'label': 'Last Demo Request Date/Time',
            'type': 'datetime',
            'fieldType': 'date',
            'description': '',
            'groupName': 'salesforceinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163395005,
    'updatedAt': 1744823092149,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'fr',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":537028710,"label":"Je veux en savoir plus. Je souhaite m’inscrire pour recevoir des communications marketing de Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"J\'accepte que Klaviyo Sandbox stocke et traite mes données personnelles.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743856,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744823092149,
    'businessUnitId': 0,
    'portableKey': '8368b887-ad11-4a2a-946a-7ba9137c72d0',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // SPANISHMAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '0158aa5c-8f1f-4d6c-b4c4-679e16f909c9',
    'name': ' Main Demo Form - Spanish (ES)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Enviar',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nombre',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Apellidos',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Correo electrónico',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Número de teléfono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sitio web de la empresa',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Número de contactos',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1000-3000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3000-25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000-100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000-500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000-1&nbsp;000&nbsp;000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Más de un millón',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date_time',
            'label': 'Last Demo Request Date/Time',
            'type': 'datetime',
            'fieldType': 'date',
            'description': '',
            'groupName': 'salesforceinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1742363354380,
    'updatedAt': 1744788819618,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'esES',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":537028710,"label":"Quiero saber más y suscribirme a las comunicaciones de marketing de Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Acepto que Klaviyo Sandbox almacene y trate mis datos personales.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743856,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744788819618,
    'businessUnitId': 0,
    'portableKey': '18f66bbb-aa9b-417c-9b26-ddd6d849befd',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // GERMAN MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': 'cb4baa41-95c1-4cfd-9e7b-417d19a0bea2',
    'name': 'Main Demo Form - German (DE)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Senden',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Vorname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nachname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Telefonnummer',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Website des Unternehmens',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Anzahl der Kontakte',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0-1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000-3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000-25.0000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000–500.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000-500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000–1&nbsp;Mio.',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '+1&nbsp;Mio.',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date_time',
            'label': 'Last Demo Request Date/Time',
            'type': 'datetime',
            'fieldType': 'date',
            'description': '',
            'groupName': 'salesforceinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163606041,
    'updatedAt': 1744822847819,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'de',
      },
      {
        'name': 'clonedFromForm',
        'value': 'bc51f195-7772-4a17-b5b8-8f152c063914',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":537028710,"label":"Ich würde gern mehr erfahren und möchte Marketing-Nachrichten von Klaviyo erhalten.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Ich stimme der Speicherung und Verarbeitung meiner personenbezogenen Daten durch Klaviyo Sandbox zu.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743856,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744822847819,
    'businessUnitId': 0,
    'portableKey': '18b9cca8-3ed5-4ef4-8bfa-46a1edab9873',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  // ITALIAN MAIN DEMO FORM SANDBOX
  {
    'portalId': 48753160,
    'guid': '325369ac-8d5a-48f3-9a6b-4e98ca8168a3',
    'name': 'Main Demo Form - Italian (IT)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Invia',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Cognome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail&#xa0;',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numero di telefono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sito web dell\'azienda',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Numero di contatti',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000 - 3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000 - 25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000 - 100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000 - 500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000 - 1.000.000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Oltre 1.000.000',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'attribution_properties',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date_time',
            'label': 'Last Demo Request Date/Time',
            'type': 'datetime',
            'fieldType': 'date',
            'description': '',
            'groupName': 'salesforceinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741163653409,
    'updatedAt': 1744822919782,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'it',
      },
      {
        'name': 'clonedFromForm',
        'value': '9b002344-d150-4afe-b8f6-4c8d0df6405b',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":537028710,"label":"Voglio saperne di più e iscrivermi alle comunicazioni di marketing di Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Consento a Klaviyo Sandbox di archiviare e elaborare i miei dati personali.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743856,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744822919782,
    'businessUnitId': 0,
    'portableKey': '7d741c5d-5aaf-4cf0-91b7-7412a47235f6',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },

  //ENGLISH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
    'name': 'Main Demo Form - English (EN)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Submit',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'First name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Last name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Phone number',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Email Address',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Company Website',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Number of contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1K',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1K - 3K',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3K - 25K',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25K - 100K',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100K - 500K',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500K - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M+',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741762505703,
    'updatedAt': 1744832263394,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'en',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":459966465,"label":"You consent to receive Klaviyo’s marketing communications including newsletters, blog posts, product news, webinars, and targeted advertising. You can unsubscribe from our marketing emails at any time by clicking on the “Unsubscribe” link at the bottom of our emails. For more information, please see our <a href=\\"https://www.klaviyo.com/legal/privacy/privacy-notice\\" target=\\"_blank\\" rel=\\"noopener\\">Privacy Policy</a>.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"I agree to allow Klaviyo to store and process my personal data.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743855,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744832263394,
    'businessUnitId': 0,
    'portableKey': 'ae1fb3b3-6ce0-44ad-b9db-1cc1b2f80381',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //FRENCH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': 'c24f3125-e60b-47d4-a2bc-ab9c02f66d26',
    'name': 'Main Demo Form - French (FR)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Soumettre',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Prénom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nom',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Adresse e-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numéro de téléphone',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Site web de l’entreprise',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Nombre de contacts',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1&nbsp;000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1&nbsp;000 - 3&nbsp;000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3&nbsp;000 - 25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000 - 100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000 - 500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000 - 1M',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1M et +',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Source UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Support UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagne UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenu UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Terme UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date',
            'label': 'Last Demo Request Date',
            'type': 'date',
            'fieldType': 'date',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741762810323,
    'updatedAt': 1744786137277,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'fr',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":459966465,"label":"Je veux en savoir plus. Je souhaite m’inscrire pour recevoir des communications marketing de Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"J\'accepte que Klaviyo stocke et traite mes données personnelles.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743855,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744786137277,
    'businessUnitId': 0,
    'portableKey': '0560d507-1f43-420d-8d71-cded30ad7b29',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //SPANISH MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '3c37745a-8e57-40a1-abeb-fb0cd4c4dd69',
    'name': 'Main Demo Form - Spanish (ES)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Enviar',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nombre',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Apellidos',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'Correo electrónico',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Número de teléfono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sitio web de la empresa',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Número de contactos',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1000-3000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3000-25&nbsp;000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25&nbsp;000-100&nbsp;000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100&nbsp;000-500&nbsp;000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500&nbsp;000-1&nbsp;000&nbsp;000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Más de un millón',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM Term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date',
            'label': 'Last Demo Request Date',
            'type': 'date',
            'fieldType': 'date',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1742363495428,
    'updatedAt': 1744786476316,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'esES',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":459966465,"label":"Quiero saber más y suscribirme a las comunicaciones de marketing de Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Acepto que Klaviyo almacene y trate mis datos personales.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743855,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744786476316,
    'businessUnitId': 0,
    'portableKey': '63d964e1-cd36-4d68-85a8-fe6c5bb576c1',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //GERMAN MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': '348a481d-152a-4706-bc8a-740640429210',
    'name': 'Main Demo Form - German (DE)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Senden',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Vorname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Nachname',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-Mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Telefonnummer',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Website des Unternehmens',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Anzahl der Kontakte',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0-1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000-3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000-25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000-100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000–500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000–1&nbsp;Mio.',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '+1&nbsp;Mio.',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'UTM Source',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'UTM Medium',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'UTM Campaign',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'UTM Content',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'UTM term',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date',
            'label': 'Last Demo Request Date',
            'type': 'date',
            'fieldType': 'date',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741763133798,
    'updatedAt': 1744822655693,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'de',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":459966465,"label":"Ich würde gern mehr erfahren und möchte Marketing-Nachrichten von Klaviyo erhalten.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Ich stimme der Speicherung und Verarbeitung meiner personenbezogenen Daten durch Klaviyo zu.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743855,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744822655693,
    'businessUnitId': 0,
    'portableKey': '00510673-1a0c-4738-94fc-a99fc5760593',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
  //ITALIAN MAIN DEMO FORM PRODUCTION
  {
    'portalId': 48163345,
    'guid': 'b61a099c-bee0-430e-8de5-faedc1b832ef',
    'name': 'Main Demo Form - Italian (IT)',
    'action': '',
    'method': 'POST',
    'cssClass': 'hs-form stacked',
    'redirect': '',
    'submitText': 'Invia',
    'followUpId': '',
    'notifyRecipients': '',
    'leadNurturingCampaignId': '',
    'formFieldGroups': [
      {
        'fields': [
          {
            'name': 'firstname',
            'label': 'Nome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'lastname',
            'label': 'Cognome',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'email',
            'label': 'E-mail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'phone',
            'label': 'Numero di telefono',
            'type': 'string',
            'fieldType': 'phonenumber',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '7:20:true',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'website',
            'label': 'Sito web dell\'azienda',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'list_size_from_website_form',
            'label': 'Numero di contatti',
            'type': 'enumeration',
            'fieldType': 'select',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': true,
            'selectedOptions': [],
            'options': [
              {
                'label': '0 - 1.000',
                'value': '0 - 1K',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '1.000 - 3.000',
                'value': '1K - 3K',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '3.000 - 25.000',
                'value': '3K - 25K',
                'displayOrder': 2,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '25.000 - 100.000',
                'value': '25K - 100K',
                'displayOrder': 3,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '100.000 - 500.000',
                'value': '100K - 500K',
                'displayOrder': 4,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': '500.000 - 1.000.000',
                'value': '500K - 1M',
                'displayOrder': 5,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'Oltre 1.000.000',
                'value': '1M+',
                'displayOrder': 6,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': false,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_source',
            'label': 'Fonte UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_medium',
            'label': 'Mezzo UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_content',
            'label': 'Contenuto UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_campaign',
            'label': 'Campagna UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'utm_term',
            'label': 'Termine UTM',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'gclid',
            'label': 'GCLID',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'under_marketing_privacy_policy',
            'label': 'Under Marketing Privacy Policy',
            'type': 'enumeration',
            'fieldType': 'booleancheckbox',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [
              'true',
            ],
            'options': [
              {
                'label': 'Yes',
                'value': 'true',
                'displayOrder': 0,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
              {
                'label': 'No',
                'value': 'false',
                'displayOrder': 1,
                'doubleData': 0.0,
                'hidden': false,
                'description': '',
                'readOnly': false,
              },
            ],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'conversion_page',
            'label': 'Conversion Page',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'web_pages_visited_prior_to_conversion',
            'label': 'Web Pages Visited Prior to Conversion',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'analyticsinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'last_demo_request_date_time',
            'label': 'Last Demo Request Date/Time',
            'type': 'datetime',
            'fieldType': 'date',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [
              {
                'name': 'format',
                'value': 'MM-DD-YYYY',
              },
              {
                'name': 'separator',
                'value': '/',
              },
            ],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'detail',
            'label': 'Detail',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'wbraid',
            'label': 'wbraid',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_req_id',
            'label': 'cq_req_id',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_email_verdict',
            'label': 'cq_email_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_phone_verdict',
            'label': 'cq_phone_verdict',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_action',
            'label': 'cq_action',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type',
            'label': 'cq_threat_type',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_threat_type_name',
            'label': 'cq_threat_type_name',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'cq_signals',
            'label': 'cq_signals',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': '',
            'displayOrder': 1000,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': false,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
      {
        'fields': [
          {
            'name': 'country_indicated_at_signup',
            'label': 'Country Indicated at Signup',
            'type': 'string',
            'fieldType': 'text',
            'description': '',
            'groupName': 'contactinformation',
            'displayOrder': -1,
            'required': false,
            'selectedOptions': [],
            'options': [],
            'validation': {
              'name': '',
              'message': '',
              'data': '',
              'useDefaultBlockList': false,
              'blockedEmailAddresses': [],
              'checkPhoneFormat': false,
            },
            'enabled': true,
            'hidden': true,
            'defaultValue': '',
            'isSmartField': false,
            'unselectedLabel': '',
            'placeholder': '',
            'dependentFieldFilters': [],
            'labelHidden': false,
            'propertyObjectType': 'CONTACT',
            'metaData': [],
            'objectTypeId': '0-1',
          },
        ],
        'default': true,
        'isSmartGroup': false,
        'richText': {
          'content': '',
          'type': 'TEXT',
        },
        'isPageBreak': false,
      },
    ],
    'createdAt': 1741763457107,
    'updatedAt': 1744786059035,
    'performableHtml': '',
    'migratedFrom': '',
    'ignoreCurrentValues': true,
    'metaData': [
      {
        'name': 'disableCookieSubmission',
        'value': 'true',
      },
      {
        'name': 'renderRawHtml',
        'value': 'true',
      },
      {
        'name': 'lang',
        'value': 'it',
      },
      {
        'name': 'clonedFromForm',
        'value': '3d00176e-786b-48bf-ad7e-c7a21290d2ee',
      },
      {
        'name': 'embedType',
        'value': 'REGULAR',
      },
      {
        'name': 'legalConsentOptions',
        'value': '{"communicationConsentCheckboxes":[{"communicationTypeId":459966465,"label":"Voglio saperne di più e iscrivermi alle comunicazioni di marketing di Klaviyo.","required":false}],"legitimateInterestLegalBasis":"LEGITIMATE_INTEREST_PQL","processingConsentType":"IMPLICIT","processingConsentCheckboxLabel":"Consento a Klaviyo di archiviare e elaborare i miei dati personali.","isLegitimateInterest":false}',
      },
    ],
    'deletable': true,
    'inlineMessage': 'Thanks for submitting the form.',
    'tmsId': '',
    'captchaEnabled': false,
    'campaignGuid': '',
    'cloneable': true,
    'editable': true,
    'formType': 'HUBSPOT',
    'deletedAt': 0,
    'themeName': 'canvas',
    'parentId': 4743855,
    'style': '{"fontFamily":"arial, helvetica, sans-serif","backgroundWidth":"100%","backgroundColor":"transparent","borderRadius":"0px","padding":"0px","labelTextColor":"#212D3A","linkColor":"#0000EE","clickedLinkColor":"#551A8B","labelTextSize":"13px","helpTextColor":"#516383DE","helpTextSize":"11px","legalConsentTextColor":"#33475B","legalConsentTextSize":"14px","thankYouTextColor":"#33475B","thankYouTextSize":"16px","submitColor":"#FF7A59","submitAlignment":"left","submitFontColor":"#FFFFFF","submitSize":"12px","paginationProgressColor":"#598AFF","paginationProgressTextColor":"#33475B","paginationProgressShow":true,"paginationProgressTransition":"fade","paginationProgressTheme":"default","paginationContentUseScroll":false,"paginationContentScrollHeight":"100%"}',
    'isPublished': true,
    'publishAt': 0,
    'unpublishAt': 0,
    'publishedAt': 0,
    'customUid': '',
    'createMarketableContact': false,
    'editVersion': 0,
    'thankYouMessageJson': '',
    'themeColor': '',
    'alwaysCreateNewCompany': false,
    'internalUpdatedAt': 1744786059035,
    'businessUnitId': 0,
    'portableKey': 'de48b592-2398-428a-9533-7036ba8b323d',
    'selectedExternalOptions': [],
    'embedVersion': '',
    'enrichable': false,
  },
];
